import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=fda53598&scoped=true&"
import script from "./navbar.vue?vue&type=script&lang=ts&"
export * from "./navbar.vue?vue&type=script&lang=ts&"
import style0 from "./navbar.vue?vue&type=style&index=0&id=fda53598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda53598",
  null
  
)

export default component.exports